import { Flex, Text, Center } from "@chakra-ui/react"
import Tabs from "components/UI/molecules/Tabs"
// import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { useUI } from "providers/UIProvider"
import { KEYWORD_TYPES } from "providers/LanguageSettingsProvider/LanguageSettingsProviderConstants"
import { useLanguageSettings } from "providers/LanguageSettingsProvider/LanguageSettingsProvider"
import Popover from "components/UI/atoms/Popover"
import Icon from "components/UI/atoms/Icon"

export const LanguageSettingsHeader = () => {
    const { T, toggleModal, languages } = useUI()
    const {
        currentKeywordType,
        currentLanguage,
        handleKeywordTabChange,
        handleLanguageTabChange
    } = useLanguageSettings();

    // const { languageSettings: { currentTab, handleTabChange } } = useSettings()

    const languagesTabsDisabled = currentKeywordType === KEYWORD_TYPES.TYPES

    return (
        <Flex width={"100%"} justifyContent="space-between">
            <Text fontSize={"18px"} lineHeight="28px">{T("language_settings.title")}</Text>
            <Tabs
                items={[
                    {
                        key: KEYWORD_TYPES.MOBILE,
                        // value: T("language_settings.keywords.mobile")
                        value: "Mobile"
                    },
                    {
                        key: KEYWORD_TYPES.ADMIN,
                        // value: T("language_settings.keywords.admin"),
                        value: "Admin"
                    },
                    {
                        key: KEYWORD_TYPES.TYPES,
                        // value: T("language_settings.keywords.types"),
                        value: "Types"
                    }
                ]}
                currentTab={currentKeywordType}
                handleTabChange={handleKeywordTabChange}
            />
            <Flex
                opacity={languagesTabsDisabled ? "0.3" : "1"}
                pointerEvents={languagesTabsDisabled ? "none" : "auto"}
            >
                <Popover
                    rootElement={(
                        <Center
                            as="button"
                            w="49px"
                            h="49px"
                            bg="var(--chakra-colors-input_border_color_primary)"
                            borderRadius="50%"
                            mr="10px"
                            onClick={() => toggleModal("addLanguageModal", true)}
                        >
                            <Icon
                                name="add_circle"
                                iconStyles={{
                                    width: "24px",
                                    height: "24px",
                                    fill: "var(--chakra-colors-button_grey_bg)"
                                }}
                            />
                        </Center>
                    )}
                    content={T("language_settings.langs.add_lang")}
                    placement="bottom"
                    trigger="hover"
                />
                <Tabs
                    height="49"
                    width="147"
                    renderOnlyIcons
                    items={languages?.map((langauge) => ({
                        key: langauge.code,
                        icon: langauge.flagImageUrl
                    }))}
                    currentTab={currentLanguage}
                    handleTabChange={handleLanguageTabChange}
                />
            </Flex>
        </Flex>
    )
}

export default LanguageSettingsHeader